import { DeletePhotoContainer } from '../styled/File.style'
import trashSvg from './../../assets/svg/trash.svg'

interface DeletePhotoCmdItemProps {
  onClickHandler: Function
}

const DeletePhotoCmdItem = ({onClickHandler} : DeletePhotoCmdItemProps) => {
  return (
    <DeletePhotoContainer onClick={onClickHandler}>
      <p>Elimina</p>
      <img src={trashSvg} alt="trash icon" />
    </DeletePhotoContainer>
  )
}

export default DeletePhotoCmdItem